<template>
  <div class="background-image lg:px-8">
    <div class="max-w-7xl mx-auto py-5">
      <div class="flex items-center justify-center px-5 lg:px-0">
        <div class="flex-grow border-t-2 border-black"></div>
        <h2
          class="text-[21px] lg:text-3xl text-[#001c54] font-semibold text-center mt-4 mb-4"
        >
          OUR HIRING PARTNERS
        </h2>
        <div class="flex-grow border-t-2 border-black"></div>
      </div>
      <!--desktop-->
      <div class="hidden md:block my-4 relative">
        <div
          class="absolute bottom-0 right-0 top-[150px] md:top-[40%] md:right-0 z-10 cursor-pointer"
        >
          <img
            src="@/assets/MbaFinance/right-arrow.png"
            class="nexthiring w-[30px] h-[30px]"
            width="30px"
            height="40px"
            alt=""
          />
        </div>

        <div class="max-w-6xl mx-auto">
          <div class="hiring_rank_des px-8 xl:px-0">
            <!-- 1st  -->
            <div class="">
              <div class="flex gap-2 mb-2 justify-between items-center">
                <div
                  class="w-[238px] h-[92px] flex flex-col items-center justify-center shadow-lg border bg-white p-1 rounded-md"
                >
                  <div>
                    <img
                      class=""
                      src="@/assets/LPnew/images/recruit/place-img1.png"
                      alt="one"
                      loading="lazy"
                      decoding="async"
                    />
                  </div>
                </div>

                <div
                  class="w-[238px] h-[92px] flex flex-col items-center justify-center shadow-lg bg-white p-1 rounded-md"
                >
                  <div>
                    <img
                      class=""
                      src="@/assets/LPnew/images/recruit/place-img3.png"
                      alt="two"
                      loading="lazy"
                      decoding="async"
                    />
                  </div>
                </div>
                <div
                  class="w-[238px] h-[92px] flex flex-col items-center justify-center shadow-lg bg-white p-1 rounded-md"
                >
                  <div>
                    <img
                      class=""
                      src="@/assets/LPnew/images/recruit/place-img5.png"
                      alt="five"
                      loading="lazy"
                      decoding="async"
                    />
                  </div>
                </div>
                <div
                  class="w-[238px] h-[92px] flex flex-col items-center justify-center shadow-lg bg-white p-1 rounded-md"
                >
                  <div>
                    <img
                      class=""
                      src="@/assets/LPnew/images/recruit/place-img1.png"
                      alt="six"
                      loading="lazy"
                      decoding="async"
                    />
                  </div>
                </div>
              </div>
              <div class="flex gap-2 mb-2 justify-between items-center mt-4">
                <div
                  class="w-[238px] h-[92px] flex flex-col items-center justify-center shadow-lg bg-white p-1 rounded-md"
                >
                  <div>
                    <img
                      class=""
                      src="@/assets/LPnew/images/recruit/place-img2.png"
                      alt="three"
                      loading="lazy"
                      decoding="async"
                    />
                  </div>
                </div>

                <div
                  class="w-[238px] h-[92px] flex flex-col items-center justify-center shadow-lg bg-white p-1 rounded-md"
                >
                  <div>
                    <img
                      class=""
                      src="@/assets/LPnew/images/recruit/place-img4.png"
                      alt="four"
                      loading="lazy"
                      decoding="async"
                    />
                  </div>
                </div>
                <div
                  class="w-[238px] h-[92px] flex flex-col items-center justify-center shadow-lg bg-white p-1 rounded-md"
                >
                  <div>
                    <img
                      class=""
                      src="@/assets/LPnew/images/recruit/place-img6.png"
                      alt="seven"
                      loading="lazy"
                      decoding="async"
                    />
                  </div>
                </div>

                <div
                  class="w-[238px] h-[92px] flex flex-col items-center justify-center shadow-lg bg-white p-1 rounded-md"
                >
                  <div>
                    <img
                      class=""
                      src="@/assets/LPnew/images/recruit/place-img2.png"
                      alt="eight"
                      loading="lazy"
                      decoding="async"
                    />
                  </div>
                </div>
              </div>
            </div>
            <!-- 2nd  -->
            <div class="">
              <div class="flex gap-2 mb-2 justify-between items-center">
                <div
                  class="w-[238px] h-[92px] flex flex-col items-center justify-center shadow-lg border bg-white p-1 rounded-md"
                >
                  <div>
                    <img
                      class=""
                      src="@/assets/LPnew/images/recruit/place-img1.png"
                      alt="one"
                      loading="lazy"
                      decoding="async"
                    />
                  </div>
                </div>

                <div
                  class="w-[238px] h-[92px] flex flex-col items-center justify-center shadow-lg bg-white p-1 rounded-md"
                >
                  <div>
                    <img
                      class=""
                      src="@/assets/LPnew/images/recruit/place-img3.png"
                      alt="two"
                      loading="lazy"
                      decoding="async"
                    />
                  </div>
                </div>
                <div
                  class="w-[238px] h-[92px] flex flex-col items-center justify-center shadow-lg bg-white p-1 rounded-md"
                >
                  <div>
                    <img
                      class=""
                      src="@/assets/LPnew/images/recruit/place-img5.png"
                      alt="five"
                      loading="lazy"
                      decoding="async"
                    />
                  </div>
                </div>
                <div
                  class="w-[238px] h-[92px] flex flex-col items-center justify-center shadow-lg bg-white p-1 rounded-md"
                >
                  <div>
                    <img
                      class=""
                      src="@/assets/LPnew/images/recruit/place-img1.png"
                      alt="six"
                      loading="lazy"
                      decoding="async"
                    />
                  </div>
                </div>
              </div>
              <div class="flex gap-2 mb-2 justify-between items-center mt-4">
                <div
                  class="w-[238px] h-[92px] flex flex-col items-center justify-center shadow-lg bg-white p-1 rounded-md"
                >
                  <div>
                    <img
                      class=""
                      src="@/assets/LPnew/images/recruit/place-img2.png"
                      alt="three"
                      loading="lazy"
                      decoding="async"
                    />
                  </div>
                </div>

                <div
                  class="w-[238px] h-[92px] flex flex-col items-center justify-center shadow-lg bg-white p-1 rounded-md"
                >
                  <div>
                    <img
                      class=""
                      src="@/assets/LPnew/images/recruit/place-img4.png"
                      alt="four"
                      loading="lazy"
                      decoding="async"
                    />
                  </div>
                </div>
                <div
                  class="w-[238px] h-[92px] flex flex-col items-center justify-center shadow-lg bg-white p-1 rounded-md"
                >
                  <div>
                    <img
                      class=""
                      src="@/assets/LPnew/images/recruit/place-img6.png"
                      alt="seven"
                      loading="lazy"
                      decoding="async"
                    />
                  </div>
                </div>

                <div
                  class="w-[238px] h-[92px] flex flex-col items-center justify-center shadow-lg bg-white p-1 rounded-md"
                >
                  <div>
                    <img
                      class=""
                      src="@/assets/LPnew/images/recruit/place-img2.png"
                      alt="eight"
                      loading="lazy"
                      decoding="async"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="absolute bottom-0 left-0 top-[150px] md:top-[40%] z-10 cursor-pointer"
        >
          <img
            src="@/assets/MbaFinance/left-arrow.png"
            width="30px"
            height="40px"
            class="prevhiring"
            alt=""
          />
        </div>
      </div>
      <!--desktop-->
      <!--mobile-->
      <div class="md:hidden my-2 relative">
        <div
          class="absolute bottom-0 right-0 top-[45px] md:top-[40%] md:right-0 z-10 cursor-pointer"
        >
          <img
            src="@/assets/MbaFinance/right-arrow.png"
            class="nexthiring_mob w-[30px] h-[30px]"
            width="30px"
            height="40px"
            alt=""
          />
        </div>
        <div class="w-[80%] mx-auto">
          <div class="hiring_rank_mob">
            <!-- 1st  -->
            <div class="!w-[270px]">
              <div class="flex gap-2 mb-2 justify-between items-center">
                <div
                  class="w-[155px] flex flex-col items-center justify-center shadow-lg border bg-white p-1 rounded-md"
                >
                  <div>
                    <img
                      class=""
                      src="@/assets/LPnew/images/recruit/place-img1.png"
                      alt="one"
                      loading="lazy"
                      decoding="async"
                    />
                  </div>
                </div>

                <div
                  class="w-[155px] flex flex-col items-center justify-center shadow-lg bg-white p-1 rounded-md"
                >
                  <div>
                    <img
                      class=""
                      src="@/assets/LPnew/images/recruit/place-img3.png"
                      alt="two"
                      loading="lazy"
                      decoding="async"
                    />
                  </div>
                </div>
              </div>
              <div class="flex gap-2 mb-2 justify-between items-center mt-4">
                <div
                  class="w-[155px] flex flex-col items-center justify-center shadow-lg bg-white p-1 rounded-md"
                >
                  <div>
                    <img
                      class=""
                      src="@/assets/LPnew/images/recruit/place-img2.png"
                      alt="three"
                      loading="lazy"
                      decoding="async"
                    />
                  </div>
                </div>

                <div
                  class="w-[155px] flex flex-col items-center justify-center shadow-lg bg-white p-1 rounded-md"
                >
                  <div>
                    <img
                      class=""
                      src="@/assets/LPnew/images/recruit/place-img4.png"
                      alt="four"
                      loading="lazy"
                      decoding="async"
                    />
                  </div>
                </div>
              </div>
            </div>

            <!-- 2nd  -->
            <div class="!w-[270px]">
              <div class="flex gap-2 mb-2 justify-between items-center">
                <div
                  class="w-[150px] flex flex-col items-center justify-center shadow-lg bg-white p-1 rounded-md"
                >
                  <div>
                    <img
                      class=""
                      src="@/assets/LPnew/images/recruit/place-img3.png"
                      alt="five"
                      loading="lazy"
                      decoding="async"
                    />
                  </div>
                </div>

                <div
                  class="w-[150px] flex flex-col items-center justify-center shadow-lg bg-white p-1 rounded-md"
                >
                  <div>
                    <img
                      class=""
                      src="@/assets/LPnew/images/recruit/place-img5.png"
                      alt="six"
                      loading="lazy"
                      decoding="async"
                    />
                  </div>
                </div>
              </div>
              <div class="flex gap-2 mb-2 justify-between items-center mt-4">
                <div
                  class="w-[150px] flex flex-col items-center justify-center shadow-lg bg-white p-1 rounded-md"
                >
                  <div>
                    <img
                      class=""
                      src="@/assets/LPnew/images/recruit/place-img4.png"
                      alt="seven"
                      loading="lazy"
                      decoding="async"
                    />
                  </div>
                </div>

                <div
                  class="w-[150px] flex flex-col items-center justify-center shadow-lg bg-white p-1 rounded-md"
                >
                  <div>
                    <img
                      class=""
                      src="@/assets/LPnew/images/recruit/place-img6.png"
                      alt="eight"
                      loading="lazy"
                      decoding="async"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="!w-[270px]">
              <div class="flex gap-2 mb-2 justify-between items-center">
                <div
                  class="w-[150px] flex flex-col items-center justify-center shadow-lg bg-white p-1 rounded-md"
                >
                  <div>
                    <img
                      class=""
                      src="@/assets/LPnew/images/recruit/place-img5.png"
                      alt="five"
                      loading="lazy"
                      decoding="async"
                    />
                  </div>
                </div>

                <div
                  class="w-[150px] flex flex-col items-center justify-center shadow-lg bg-white p-1 rounded-md"
                >
                  <div>
                    <img
                      class=""
                      src="@/assets/LPnew/images/recruit/place-img1.png"
                      alt="six"
                      loading="lazy"
                      decoding="async"
                    />
                  </div>
                </div>
              </div>
              <div class="flex gap-2 mb-2 justify-between items-center mt-4">
                <div
                  class="w-[150px] flex flex-col items-center justify-center shadow-lg bg-white p-1 rounded-md"
                >
                  <div>
                    <img
                      class=""
                      src="@/assets/LPnew/images/recruit/place-img6.png"
                      alt="seven"
                      loading="lazy"
                      decoding="async"
                    />
                  </div>
                </div>

                <div
                  class="w-[150px] flex flex-col items-center justify-center shadow-lg bg-white p-1 rounded-md"
                >
                  <div>
                    <img
                      class=""
                      src="@/assets/LPnew/images/recruit/place-img2.png"
                      alt="eight"
                      loading="lazy"
                      decoding="async"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="absolute bottom-0 left-0 top-[45px] md:top-[40%] z-10 cursor-pointer"
        >
          <img
            src="@/assets/MbaFinance/left-arrow.png"
            width="30px"
            height="40px"
            class="prevhiring_mob"
            alt=""
          />
        </div>
      </div>
      <!--mobile-->
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import "slick-carousel";
export default {
  name: "hiringVue",
  data() {
    return {};
  },
  mounted() {
    $(`.hiring_rank_des`).slick({
      infinite: true,
      autoplay: true,
      slidesToShow: 1,
      prevArrow: $(".prevhiring"),
      nextArrow: $(".nexthiring"),
      dots: false,
    });
    $(`.hiring_rank_mob`).slick({
      infinite: true,
      autoplay: true,
      prevArrow: $(".prevhiring_mob"),
      nextArrow: $(".nexthiring_mob"),
      slidesToShow: 4,
      slidesToScroll: 1,
      dots: false,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 950,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 650,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });
  },
};
</script>

<style scoped>
.background-image {
  background-image: url("@/assets/LPnew/images/recruitBG.jpg");
  background-size: cover;
}
</style>
